import * as React from "react";
import { Shield, TrendingUp, ChartCandlestick } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const features = [{
  subheading: "IGNITION SYSTEM",
  title: "Ignition Parts",
  description: "High-precision pulser coils and ignition assemblies engineered for Japanese OEM standards.",
  icon: Shield
}, {
  subheading: "FUEL MANAGEMENT",
  title: "Fuel Systems",
  description: "Premium primer pumps and fuel pipe components designed for maximum marine performance.",
  icon: TrendingUp
}, {
  subheading: "MECHANICAL COMPONENTS",
  title: "Gears & Seals",
  description: "Industrial-grade bearings, pinion gears, and oil seals built for harsh ocean environments.",
  icon: ChartCandlestick
}];
export default function ProductCategories() {
  return <section data-section-id="252226" id="product-categories" className="w-full py-16 md:py-24 bg-muted text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {features.map((feature, i) => <Card key={i} data-index={i} className="bg-card border border-border/50 shadow-sm hover:shadow-lg hover:scale-105 transition-all duration-300 rounded-md overflow-hidden">
              <CardContent className="p-8 md:p-10">
                <div className="flex justify-between items-start mb-10">
                  <div className="w-8 h-0.5 bg-primary mt-2 rounded-lg"></div>
                  <div className="bg-secondary/30 px-2 py-1 rounded-sm">
                    <span className="text-[10px] font-mono font-bold text-primary tracking-tighter">OEM-SPEC</span>
                  </div>
                </div>
                
                <div>
                  <p className="text-xs font-mono font-semibold tracking-widest text-muted-foreground uppercase mb-2">
                    {feature.subheading}
                  </p>
                  <h3 className="text-3xl md:text-4xl font-bold font-default text-primary mb-4">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed font-sans">
                    {feature.description}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {}
        <div className="bg-primary rounded-md p-8 md:p-12 lg:p-16 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 shadow-xl border border-primary/20">
          <div className="max-w-3xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-primary-foreground leading-tight tracking-tight">
              Premium Marine Spare Parts Engineered for Trusted Performance
            </h2>
          </div>
          <div className="shrink-0">
            <Button asChild size="lg" className="bg-secondary text-primary hover:bg-secondary/90 rounded-md px-8 h-14 text-base font-bold shadow-md transition-transform hover:scale-105">
              <Link to="/ProductsPage">
                View All Categories
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}